import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./RotatingText.css";

const RotatingText = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const texts = ["Systems", "Processes", "Operations"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => prevIndex + 1); // Loop through texts
    }, 3000);
    return () => clearInterval(interval);
  }, [texts.length]);

  // 3D rotation angle
  const rotationAngle = -120 * currentIndex;

  // Link for the 'Integrate AI' button
  const surveyURL = "https://forms.gle/7GV5NDXaKx4kqCQB8";

  return (
    <div className="rotating-text-container">
      {/* Use Container fluid if you truly want full-width, otherwise remove "fluid" */}
      <Container fluid>
        {/*
          Row for "Automate" + rotating carousel.
          Add top margin (mt-5) to give breathing room from top nav or page edge.
          Add bottom margin (mb-4) to separate from the next heading.
        */}
        <Row className="align-items-center text-and-carouseled mt-5 mb-4">
          <Col xs={12} lg={6} className="text-left text-lg-end static-text-wrapper">
            <h1 className="static-text">Automate</h1>
          </Col>
          <Col xs={12} lg={6} className="carouseled-container">
            <div className="carouseled">
              <div
                className="carouseled-inner"
                style={{ transform: `rotateX(${rotationAngle}deg)` }}
              >
                {texts.map((text, index) => {
                  const isActive = currentIndex % texts.length === index;
                  return (
                    <div
                      key={index}
                      className={`carouseled-item ${isActive ? "active" : ""}`}
                    >
                      {text}
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>

        {/*
          "With AI" heading.
          Give it a little margin-bottom (mb-3) so there's space before the paragraph.
        */}
        <Row className="mb-3">
          <Col xs={12} className="text-center">
            <h1 className="static-text">With AI</h1>
          </Col>
        </Row>

        {/*
          Description paragraph row.
          Add bottom margin (mb-4) to separate from the buttons.
        */}
        <Row className="d-flex justify-content-center mb-4">
          <Col xs={12} md={8}>
            <p className="text-center description">
              Transform your operations with cutting-edge AI solutions that
              enhance efficiency and scalability.
            </p>
          </Col>
        </Row>

        {/*
          Buttons row.
          Add more bottom margin (mb-5) if you want extra space below the buttons
          for a cleaner end of the hero section.
        */}
        <Row className="justify-content-center buttons mb-5">
          <Col xs={12} md="auto" className="text-center">
            <Button className="demo-button">
              Book a Demo →
              <div className="popup-card">
                Click the 'Integrate AI' button to complete a brief survey and
                help us tailor AI solutions to fit your workflow.
              </div>
            </Button>
          </Col>
          <Col xs={12} md="auto" className="text-center">
            <a
              href={surveyURL}
              target="_blank"
              rel="noopener noreferrer"
              className="build-button-link"
            >
              <Button className="build-button">Integrate AI →</Button>
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RotatingText;
